import { Controller, useFormContext } from "react-hook-form";

import { Paper } from "@mui/material";
import Grid from "@mui/material/Grid";

import { PaymentTermSelect } from "@/features/payment-terms";
import { CustomInputField } from "@/features/ui";

export const OtherSection = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
          <Controller
            name="paymentTerm"
            control={control}
            render={({ field, fieldState }) => (
              <PaymentTermSelect
                value={field.value}
                onChange={field.onChange}
                TextFieldProps={{
                  required: true,
                  label: "Syarat Pembayaran",
                  error: fieldState.invalid,
                  helperText: fieldState.error?.message,
                  InputProps: {
                    placeholder: "Pilih",
                  },
                }}
              />
            )}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 12, lg: 6 }}>
          <CustomInputField
            name="note"
            label="Catatan"
            register={register}
            helperText={errors.note?.message}
            error={Boolean(errors.note)}
            InputProps={{
              multiline: true,
              minRows: 2,
              maxRows: 3,
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
